<template>
  <div>
    <PageHeader :gradientType="gradientType" />
    <PageContent>
      <template #filterBar>
        <div>
          <div>
            <h6 class="heading-small text-muted mb-4">Template</h6>
            <div class="row mb-3">
              <div class="col">
                <a-select
                  v-model="selectedAccountReportTemplateId"
                  style="width: 100%"
                  placeholder="Select Template"
                  :filter-option="filterOption"
                  @change="
                    (event) => {
                      setAccountReportTemplate(event);
                      setOrigConfig(event);
                    }
                  "
                >
                  <a-select-option
                    v-for="template in options.accountReportTemplates"
                    :value="template.id"
                    :key="template.id"
                    :label="template.name"
                  >
                    {{ template.name }}
                  </a-select-option>
                </a-select>
              </div>
            </div>
          </div>
        </div>
        <br />
        <form role="form" @submit.prevent>
          <h6 class="heading-small text-muted mb-4">Filters</h6>
          <div>
            <div>
              <label>Report Type Display</label>
            </div>
            <div class="row mb-3">
              <div class="col">
                <a-select
                  v-model="table.appendedParams.report_type"
                  style="width: 100%"
                  placeholder="Select Report Type"
                  :filter-option="filterOption"
                  @change="onChangeReportType"
                >
                  <a-select-option
                    v-for="reportType in options.reportTypes"
                    :value="reportType.id"
                    :key="reportType.id"
                    :label="reportType.name"
                  >
                    {{ reportType.name }}
                  </a-select-option>
                </a-select>
              </div>
            </div>
          </div>
          <div>
            <div>
              <label>Membership Program</label>
            </div>
            <div class="row mb-3">
              <div class="col">
                <a-select
                  v-model="table.appendedParams.membership_program_ids"
                  mode="multiple"
                  style="width: 100%"
                  :filter-option="filterOption"
                  placeholder="Select Membership Programs"
                >
                  <a-select-option
                    v-for="membershipProgram in options.membershipPrograms"
                    :value="membershipProgram.id"
                    :key="membershipProgram.id"
                    :label="membershipProgram.name"
                  >
                    {{ membershipProgram.name }}
                  </a-select-option>
                </a-select>
              </div>
            </div>
          </div>
          <div>
            <div>
              <label>Membership Level</label>
            </div>
            <div class="row">
              <div class="col">
                <a-select
                  v-model="table.appendedParams.membership_level_ids"
                  mode="multiple"
                  style="width: 100%"
                  :filter-option="filterOption"
                  placeholder="Select Membership Level"
                >
                  <a-select-option
                    v-for="membershipLevels in options.membershipLevels"
                    :value="membershipLevels.id"
                    :key="membershipLevels.id"
                    :label="membershipLevels.name"
                  >
                    {{ membershipLevels.name }}
                  </a-select-option>
                </a-select>
              </div>
            </div>
          </div>
          <div>
            <div>
              <label>Transaction Date </label>
            </div>
            <div class="row">
              <div class="col">
                <base-input>
                  <a-range-picker
                    v-model="table.appendedParams.date_range"
                    :default-value="[
                      table.appendedParams.date_from,
                      table.appendedParams.date_to
                    ]"
                    :format="dateFormat"
                    @change="dateRangeOnChange"
                  />
                </base-input>
              </div>
            </div>
          </div>
          <div>
            <div>
              <label>Selling Type</label>
            </div>
            <div class="row mb-3">
              <div class="col">
                <a-select
                  v-model="table.appendedParams.selling_type_ids"
                  mode="multiple"
                  style="width: 100%"
                  :filter-option="filterOption"
                  placeholder="Select Selling Type"
                >
                  <a-select-option
                    v-for="sellingType in options.sellingTypes"
                    :value="sellingType.id"
                    :key="sellingType.id"
                    :label="sellingType.name"
                  >
                    {{ sellingType.name }}
                  </a-select-option>
                </a-select>
              </div>
            </div>
          </div>
          <div>
            <div>
              <label>Payment</label>
            </div>
            <div class="row mb-3">
              <div class="col">
                <a-select
                  v-model="table.appendedParams.payment_ids"
                  mode="multiple"
                  style="width: 100%"
                  :filter-option="filterOption"
                  placeholder="Select Payment"
                >
                  <a-select-option
                    v-for="payment in options.payments"
                    :value="payment.id"
                    :key="payment.id"
                    :label="payment.name"
                  >
                    {{ payment.name }}
                  </a-select-option>
                </a-select>
              </div>
            </div>
          </div>
          <div>
            <div>
              <label>Site</label>
            </div>
            <div class="row mb-3">
              <div class="col">
                <a-select
                  v-model="table.appendedParams.site_ids"
                  mode="multiple"
                  style="width: 100%"
                  :filter-option="filterOption"
                  placeholder="Select Sites"
                >
                  <a-select-option
                    v-for="site in options.sites"
                    :value="site.id"
                    :key="site.id"
                    :label="site.name"
                  >
                    {{ site.name }}
                  </a-select-option>
                </a-select>
              </div>
            </div>
          </div>
          <div v-if="table.appendedParams.report_type != 'aggregate'">
            <div>
              <label> Customer Name</label>
            </div>
            <div class="row">
              <div class="col">
                <base-input>
                  <a-input
                    placeholder="First Name/Last Name"
                    v-model="table.appendedParams.customer_name"
                  />
                </base-input>
              </div>
            </div>
          </div>
          <div v-if="table.appendedParams.report_type != 'aggregate'">
            <div>
              <label>Recruiter</label>
            </div>
            <div class="row">
              <div class="col">
                <base-input>
                  <a-input
                    placeholder="Recruiter"
                    v-model="table.appendedParams.recruiter"
                  />
                </base-input>
              </div>
            </div>
          </div>
          <div v-if="table.appendedParams.report_type != 'aggregate'">
            <div>
              <label>Card Number</label>
            </div>
            <div class="row">
              <div class="col">
                <base-input>
                  <a-input
                    placeholder="Card Number"
                    v-model="table.appendedParams.card_number"
                  />
                </base-input>
              </div>
            </div>
          </div>
          <div v-if="!hasCardAssignmentModule">
            <div>
              <label>Card Type</label>
            </div>
            <div class="row mb-3">
              <div class="col">
                <a-select
                  v-model="table.appendedParams.card_type_ids"
                  mode="multiple"
                  style="width: 100%"
                  :filter-option="filterOption"
                  placeholder="Select Card Types"
                >
                  <a-select-option
                    v-for="cardType in options.cardTypes"
                    :value="cardType.id"
                    :key="cardType.id"
                    :label="cardType.name"
                  >
                    {{ cardType.name }}
                  </a-select-option>
                </a-select>
              </div>
            </div>
          </div>
          <div v-if="table.appendedParams.report_type != 'aggregate'">
            <div>
              <label>Card Transaction Type</label>
            </div>
            <div class="row mb-3">
              <div class="col">
                <a-select
                  v-model="table.appendedParams.card_transaction_type_ids"
                  mode="multiple"
                  style="width: 100%"
                  :filter-option="filterOption"
                  placeholder="Select Card Transaction Type"
                >
                  <a-select-option value="LOST_CARD">
                    Lost Card
                  </a-select-option>
                  <a-select-option value="NEW_MEMBER"
                    >New Member
                  </a-select-option>
                  <a-select-option value="RENEWAL"> Renewal </a-select-option>
                  <a-select-option value="REPLACEMENT">
                    Replacement
                  </a-select-option>
                </a-select>
              </div>
            </div>
          </div>
          <div>
            <div>
              <label>User</label>
            </div>
            <div class="row mb-3">
              <div class="col">
                <a-select
                  v-model="table.appendedParams.user_ids"
                  mode="multiple"
                  style="width: 100%"
                  :filter-option="filterOption"
                  placeholder="Select User"
                >
                  <a-select-option
                    v-for="user in options.users"
                    :value="user.id"
                    :key="user.id"
                    :label="user.user_name"
                  >
                    {{ user.user_name }}
                  </a-select-option>
                </a-select>
              </div>
            </div>
          </div>
          <div>
            <div>
              <label>Transaction Status</label>
            </div>
            <div class="row mb-3">
              <div class="col">
                <a-select
                  v-model="table.appendedParams.transaction_status"
                  mode="multiple"
                  style="width: 100%"
                  :filter-option="filterOption"
                  placeholder="Select Transaction Status"
                >
                  <a-select-option value="PAID"> Paid </a-select-option>
                  <a-select-option value="VOIDED"> Voided </a-select-option>
                </a-select>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col">
              <base-button
                type="primary btn-block"
                class="my-4"
                @click.prevent="applyFilter"
              >
                <div>Apply Filter</div>
              </base-button>
            </div>
          </div>
        </form>
      </template>

      <template #pageTable>
        <PageTable
          :tableTitle="table.title"
          :apiUrl="table.apiUrl"
          :tableFields="table.fields"
          :appendedParams="table.appendedParams"
          :sortOrder="table.sortOrder"
          :sortParams="getSortParam"
          :multiSort="table.multiSort"
          :multiSortKey="table.multiSortKey"
        >
          <template #headerButtons>
            <div>
              <b-button
                v-if="selectedActions.includes('Customize')"
                variant="primary"
                @click.prevent="openDrawer('report_template')"
                >Customize</b-button
              >
              <b-button
                v-if="
                  selectedActions.includes('Download') ||
                  selectedActions.includes('Send')
                "
                variant="danger"
                @click.prevent="openDrawer('export_data')"
                >Export</b-button
              >
            </div>
          </template>

          <template #formDrawer>
            <a-drawer
              :width="drawer.width"
              :placement="drawer.placement"
              :visible="drawer.visible"
              @close="closeDrawer"
            >
              <AccountReportTemplate
                v-if="drawer.action == 'report_template'"
                :accountReport="accountReport"
                :accountReportTemplate="accountReportTemplate"
                :selectedAccountReportTemplateColumns="tableFields"
                :selectedAccountReportTemplateFilters="table.appendedParams"
                :selectedAccountReportTemplateSorts="table.sortOrder"
                :updatedFilter="updatedFilters"
                @setTableColumns="setTableColumns"
                @setAccountReportTemplate="getAccountReportData"
                @deleteAccountReportTemplate="getAccountReportData"
                @closeDrawer="closeDrawer"
                @setUpdatedFilter="updatedFilters = false"
              />

              <ExportDataForm
                v-if="drawer.action == 'export_data'"
                :jsonFields="toJsonFields"
                :template="selectedAccountReportTemplateId"
                :filename="filename"
                :apiUrl="tableApiUrl"
                @closeDrawer="closeDrawer"
              />
            </a-drawer>
          </template>
        </PageTable>
      </template>
    </PageContent>
  </div>
</template>

<script>
import HTTPRequest from '../../../controllers/httpRequest';
import PageHeader from '../../../components/Page/Header.vue';
import PageContent from '../../../components/Page/Content.vue';
import PageTable from '../../../components/Page/Table.vue';
import AccountReportTemplate from '../Drawers/AccountReportTemplateForm.vue';
import ExportDataForm from '../Drawers/ExportDataForm.vue';
import { mapGetters } from 'vuex';
import secureStorage from '../../../controllers/secureStorage';
import moment from 'moment-timezone';

export default {
  components: {
    PageHeader,
    PageContent,
    PageTable,
    AccountReportTemplate,
    ExportDataForm
  },
  data() {
    return {
      filename: `Report - ${moment().format('YYYY-MM-DDTHHmmss.SSS')}.csv`,
      reloadTbl: true,
      updatedFilters: false,
      hasCardAssignmentModule: false,
      originalFilter: null,
      dateFormat: 'YYYY-MM-DD',
      gradientType: 'gradient-yellow',
      accountReport: null,
      accountReportTemplate: null,
      selectedAccountReportTemplateId: null,
      saveFilters: false,
      saveSorts: false,
      drawer: {
        visible: false,
        width: 600,
        placement: 'right',
        action: null
      },
      table: {
        title: 'Card Selling Reports',
        apiUrl:
          '/api/v1/reports/cards_selling?origin_site_id=' +
          secureStorage.getItem('currentSiteId'),
        fields: [],
        appendedParams: {
          user_ids: [],
          recruiter: null,
          customer_name: null,
          first_name: null,
          last_name: null,
          card_number: null,
          transaction_status: [],
          card_transaction_type_ids: [],
          membership_program_ids: [],
          membership_level_ids: [],
          selling_type_ids: [],
          payment_ids: [],
          card_type_ids: [],
          site_ids: [],
          date_range: [
            moment(new Date()).format('YYYY-MM-DD'),
            moment(new Date()).format('YYYY-MM-DD')
          ],
          date_from: moment(new Date()).format('YYYY-MM-DD'),
          date_to: moment(new Date()).format('YYYY-MM-DD'),
          report_type: 'aggregate',
          export_data: false,
          template: null,
          filter: false
        },
        multiSort: true,
        multiSortKey: 'alt',
        sortOrder: [
          {
            field: 'transaction_date',
            direction: 'asc'
          }
        ]
      },
      options: {
        users: [],
        membershipPrograms: [],
        membershipLevels: [],
        cardTypes: [],
        sellingTypes: [],
        payments: [],
        sites: [],
        reportTypes: [
          { id: 'aggregate', name: 'Consolidated' },
          { id: 'list', name: 'Listing' }
        ],
        reportTemplates: [],
        accountReportTemplates: null,
        cardStatuses: []
      }
    };
  },
  methods: {
    async getCardAssignmentFeature() {
      const response = await HTTPRequest.getRequest(
        `/api/v1/clp_accounts/settings/CARD_ASSIGNMENT_FEATURE`
      );

      if (response.account_id) {
        this.hasCardAssignmentModule = response.value;
      }
    },
    filterOption(inputValue, option) {
      return (
        option?.componentOptions?.propsData?.label
          .toLowerCase()
          .indexOf(inputValue.toLowerCase()) !== -1
      );
    },
    async getMembershipPrograms() {
      const response = await HTTPRequest.getRequest(
        '/api/v1/clp_membership_programs',
        {
          per_page: 99999
        }
      );
      this.options.membershipPrograms = response.data;
    },
    async getMembershipLevels() {
      const data = await HTTPRequest.getRequest(
        `/api/v1/clp_membership_levels`,
        {
          per_page: 99999
        }
      );
      this.options.membershipLevels = data.data.sort((a, b) =>
        a.name.localeCompare(b.name)
      );
    },
    async getUsers() {
      const data = await HTTPRequest.getRequest(`/api/v1/users`, {
        per_page: 99999
      });
      if (data.data) {
        this.options.users = data.data
          .filter(
            (user) => user?.user_name !== undefined && user?.user_name !== null
          )
          .sort((a, b) => a.user_name?.localeCompare(b.user_name) || 0);
      }
    },
    async getSellingTypes() {
      const data = await HTTPRequest.getRequest('/api/v1/card_selling_types', {
        per_page: 99999
      });

      this.options.sellingTypes = data.data.sort((a, b) =>
        a.name.localeCompare(b.name)
      );
    },
    async getPaymentTypes() {
      const response = await HTTPRequest.getRequest('/api/v1/payment_types', {
        per_page: 99999
      });
      this.options.payments = response.data.sort((a, b) =>
        a.name.localeCompare(b.name)
      );
    },

    async getCardTypes() {
      const response = await HTTPRequest.getRequest('/api/v1/clp_card_types');
      this.options.cardTypes = response.data.sort((a, b) =>
        a.name.localeCompare(b.name)
      );
    },

    async getSites() {
      const defaultSite = secureStorage.getItem('defaultSite');
      if (this.inHeadOffice) {
        this.options.sites = secureStorage.getItem('visitingSites');
      } else {
        this.options.sites = [secureStorage.getItem('currentSite')];
      }
      this.options.sites = this.options.sites.sort((a, b) =>
        a.name.localeCompare(b.name)
      );
      this.table.appendedParams.site_ids.push(defaultSite.id);
    },

    async getCardStatuses() {
      const response = await HTTPRequest.getRequest(
        '/api/v1/clp_card_statuses'
      );
      let data = [];
      for (let x in response.data) {
        if (response.data[x].model == 'cards') {
          data.push(response.data[x]);
        }
      }
      this.options.cardStatuses = data;
    },

    async getAccountReportData() {
      const reportType = this.table.appendedParams.report_type;
      let accountReport = [];

      switch (reportType.toLowerCase()) {
        case 'aggregate':
          accountReport = await HTTPRequest.getRequest(
            '/api/v1/account_reports/CARD_SELLING_REPORTS_AGGREGATE/default'
          );
          break;

        case 'list':
          accountReport = await HTTPRequest.getRequest(
            '/api/v1/account_reports/CARD_SELLING_REPORTS_LIST/default'
          );
          break;
      }

      this.accountReport = accountReport;
      await this.setAccountReportTemplate(
        accountReport.accountReportTemplates[0]
      );
      this.setOrigConfig(accountReport.accountReportTemplates[0]);
      await this.getAccountReportTemplates();
    },
    async getAccountReportTemplates() {
      const data = await HTTPRequest.getRequest(
        '/api/v1/account_report_templates/' +
          this.accountReport.code +
          '/templates'
      );
      this.options.accountReportTemplates = data;
    },

    setAccountReportTemplate(accountReportTemplate) {
      let accountReportTemplateData;
      if (typeof accountReportTemplate == 'number') {
        this.selectedAccountReportTemplateId = accountReportTemplate;
        for (const template of this.options.accountReportTemplates) {
          if (accountReportTemplate == template.id) {
            this.accountReportTemplate = template;
            accountReportTemplateData = JSON.parse(template.config);
          }
        }
      } else {
        this.accountReportTemplate = accountReportTemplate;
        accountReportTemplateData = JSON.parse(accountReportTemplate.config);
        this.selectedAccountReportTemplateId = accountReportTemplate.id;
      }

      /** Clear the previous' template's filter/s */
      this.clearTableFilters();

      /** Clear the previous' template's sort/s */
      this.clearTableSorts();

      /** Load template's default columns */
      this.setTableColumns(accountReportTemplateData.columns);

      if (
        accountReportTemplateData.filters &&
        Object.keys(accountReportTemplateData.filters).includes('source')
      ) {
        const spreadFilter = { ...accountReportTemplateData.filters };
        delete spreadFilter['source'];
        accountReportTemplateData.filters = spreadFilter;
      }
      /** Load template's default filters */
      this.setTableFilters(accountReportTemplateData.filters);

      /** Load template's default sort */
      this.setTableSorts(accountReportTemplateData.sorts);
    },

    setTableColumns(columns = []) {
      /**
       * Note: Amongst the other 2 methods on clearing the table fields,
       * this one worked as this doesn't alter the original array instance
       *
       * this.table.fields = this.table.fields.splice(0, this.table.fields.length);
       * this.table.fields = [];
       * */
      /** Clear table fields */
      this.table.fields.length = 0;
      const tableFields = this.table.fields;
      if (this.hasCardAssignmentModule) {
        columns = columns.filter(
          (item) =>
            item.name !== 'serial_no' &&
            item.name !== 'batch_number' &&
            item.name !== 'barcode' &&
            item.name !== 'card_type_name'
        );
      }
      columns.forEach((column) => {
        /** Check if current "column" is already in the table */ ``;
        let hasField = tableFields.find((field) => field.name === column.name);

        if (typeof hasField === 'undefined') {
          if (Object.keys(column).includes('value')) {
            if (column.value) {
              /** Push to table */
              if (column.name == 'transaction_date') {
                column.formatter = function (date) {
                  if (moment(date).isValid()) {
                    return moment(date).format('YYYY-MM-DD');
                  }
                  return null;
                };
              }
              this.table.fields.push(column);
            }
          } else {
            /** Push to table */
            if (column.name == 'transaction_date') {
              column.formatter = function (date) {
                if (moment(date).isValid()) {
                  return moment(date).format('YYYY-MM-DD');
                }
                return null;
              };
            }
            this.table.fields.push(column);
          }
        }
      });
    },

    setTableFilters(filters = {}) {
      if (Object.keys(filters).length !== 0) {
        this.table.appendedParams = filters;
        // setTimeout(() => this.setFilter(), 200);
      }
    },

    setTableSorts(sorts = []) {
      if (sorts && sorts.length > 0) {
        this.table.sortOrder = sorts;
        // setTimeout(() => this.setFilter(), 200);
      } else {
        this.table.sortOrder = sorts;
      }
    },

    getSortParam(sortOrder) {
      return sortOrder
        .map(function (sort) {
          return sort.field + '|' + sort.direction;
        })
        .join(',');
    },

    async onChangeReportType() {
      this.reloadTbl = false;
      /** Get report data for the report type */
      this.getAccountReportData();

      /** Clear filters for the table */
      this.clearTableFilters();

      /** Reload table */
      this.setFilter();
    },

    clearTableFilters() {
      this.table.appendedParams.user_ids = [];
      this.table.appendedParams.recruiter = null;
      this.table.appendedParams.customer_name = null;
      this.table.appendedParams.first_name = null;
      this.table.appendedParams.last_name = null;
      this.table.appendedParams.card_number = null;
      this.table.appendedParams.card_transaction_type_ids = [];
      this.table.appendedParams.membership_level_ids = [];
      this.table.appendedParams.selling_type_ids = [];
      this.table.appendedParams.payment_ids = [];
      this.table.appendedParams.export_data = false;
      this.table.appendedParams.filter = false;
      this.table.appendedParams.membership_program_ids = [];
      this.table.appendedParams.card_type_ids = [];
      this.table.appendedParams.site_ids = [];
      this.table.appendedParams.card_status_ids = [];
      this.table.appendedParams.batch_no = null;
      this.table.appendedParams.dates = [];
      this.table.appendedParams.template = null;
      this.table.appendedParams.transaction_status = [];
      this.table.appendedParams.date_range = [
        moment(new Date()).format('YYYY-MM-DD'),
        moment(new Date()).format('YYYY-MM-DD')
      ];
      this.table.appendedParams.date_from = moment(new Date()).format(
        'YYYY-MM-DD'
      );
      this.table.appendedParams.date_to = moment(new Date()).format(
        'YYYY-MM-DD'
      );
    },

    clearTableSorts() {
      this.table.sortOrder = null;
    },

    openDrawer(action) {
      this.drawer.visible = true;
      this.drawer.action = action;
    },

    closeDrawer() {
      this.drawer.visible = false;
      this.drawer.action = null;
    },
    applyFilter() {
      if (
        this.table.appendedParams.report_type != 'aggregate' &&
        this.table.appendedParams.customer_name != null &&
        this.table.appendedParams.customer_name != ''
      ) {
        const search = this.table.appendedParams.customer_name.split('/');
        typeof search[0] != 'undefined'
          ? (this.table.appendedParams['first_name'] = search[0].trim())
          : '';
        typeof search[1] != 'undefined'
          ? (this.table.appendedParams['last_name'] = search[1].trim())
          : '';
      } else {
        this.table.appendedParams.first_name = null;
        this.table.appendedParams.last_name = null;
      }
      this.reloadTbl = true;
      this.table.appendedParams.filter = true;
      this.table.appendedParams.template = this.selectedAccountReportTemplateId;
      this.setFilter();
    },
    setFilter() {
      this.originalFilter === JSON.stringify(this.table.appendedParams)
        ? (this.updatedFilters = false)
        : (this.updatedFilters = true);
      if (this.reloadTbl) {
        this.$root.$emit('refreshTable');
      }
    },

    dateRangeOnChange(dateObj, dateString) {
      this.table.appendedParams.date_from = dateString[0];
      this.table.appendedParams.date_to = dateString[1];
      this.table.appendedParams.date_range = [dateString[0], dateString[1]];

      // this.setFilter();
    },
    serializeQuery(params, prefix) {
      if (params) {
        const query = Object.keys(params).map((key) => {
          const value = params[key];

          if (params.constructor === Array) {
            key = `${prefix}[]`;
          } else if (params.constructor === Object) {
            key = prefix ? `${prefix}[${key}]` : key;
          }

          if (typeof value === 'object') {
            return this.serializeQuery(value, key);
          } else {
            return `${key}=${encodeURIComponent(value)}`;
          }
        });
        let serializedQuery = query.filter((elem) => elem != '');
        return [].concat.apply([], serializedQuery).join('&');
      }
    },
    setOrigConfig(event) {
      if (typeof event == 'number') {
        for (const template of this.options.accountReportTemplates) {
          if (event == template.id) {
            const jConfig = JSON.parse(template.config);
            if (Object.keys(jConfig).includes('filter')) {
              this.originalFilter = JSON.stringify(
                JSON.parse(jConfig.config).filters
              );
            } else {
              this.originalFilter = JSON.stringify(this.table.appendedParams);
            }
          }
        }
      } else {
        const jConfig = JSON.parse(event.config);
        if (Object.keys(jConfig).includes('filter')) {
          this.originalFilter = JSON.stringify(jConfig.filters);
        } else {
          this.originalFilter = JSON.stringify(this.table.appendedParams);
        }
      }
    }
  },
  async created() {
    await this.getCardAssignmentFeature();
    this.$store.dispatch('setCurrentModule', 'CardSellingReport');
    await this.getMembershipPrograms();
    await this.getMembershipLevels();
    await this.getUsers();
    await this.getCardTypes();
    await this.getSellingTypes();
    await this.getPaymentTypes();
    await this.getSites();
    await this.getCardStatuses();
    await this.getAccountReportData();
  },
  watch: {
    inHeadOffice: function () {
      if (this.inHeadOffice) {
        this.options.sites = secureStorage.getItem('visitingSites');
      } else {
        this.options.sites = [secureStorage.getItem('currentSite')];
      }
      this.options.sites = this.options.sites.sort((a, b) =>
        a.name.localeCompare(b.name)
      );
    }
  },
  computed: {
    tableFields() {
      const _tableFields = [...this.table.fields];
      return _tableFields;
    },

    ...mapGetters({
      selectedActions: 'getModuleSelectedActions',
      headOfficeId: 'getHeadOffice'
    }),
    inHeadOffice() {
      return secureStorage.getItem('currentSiteId') == this.headOfficeId
        ? true
        : false;
    },

    tableApiUrl() {
      const tableApiUrl = this.table.apiUrl;
      let _tableParams = { ...this.table.appendedParams };
      _tableParams.export_data = true; // Update to true, for exportable data
      const _tableSort = [...this.table.sortOrder];
      let sorts, filters;

      /** Create query string for "sort" first if there are sorting */
      if (_tableSort.length > 0) {
        let i = 0;
        for (let sort of _tableSort) {
          if (i == 0) {
            sorts = 'sort=' + sort.field + '|' + sort.direction;
          } else {
            sorts += ',' + sort.field + '|' + sort.direction;
          }
          i++;
        }
      }

      /** Parse object for query string */
      filters = this.serializeQuery(_tableParams);
      if (tableApiUrl.includes('?')) {
        return tableApiUrl + '&' + sorts + '&' + filters;
      } else {
        return tableApiUrl + '?' + sorts + '&' + filters;
      }
    },

    toJsonFields: function () {
      const _tableFields = [...this.table.fields];
      let jsonFields = {};

      for (let field of _tableFields) {
        jsonFields[field.title] = field.name;
        switch (field.name) {
          case 'card_number':
          case 'site_code':
            jsonFields[field.title] = {
              field: field.name,
              callback: (value) => {
                return '="' + value + '"';
              }
            };
            break;
          case 'transaction_date':
            jsonFields[field.title] = {
              field: field.name,
              callback: (date) => {
                if (moment(date).isValid()) {
                  return moment(date).format('YYYY-MM-DD');
                }
                return null;
              }
            };
            break;
        }
      }

      return jsonFields;
    }
  }
};
</script>

<style scoped></style>
